// @flow
import * as React from 'react'
import type { Message } from 'types/message'
import Tooltip from 'ui/atoms/Tooltip'
import Icons from 'ui/Icons'
import { DELIVERY_METHODS } from 'utils/constants'
import { momentLocal } from 'utils/helpers'

import { DATE_FORMATS, getFormattedDate } from '@/utils/dates/getFormattedDate'

import { MessageStatus } from '../MessageStatus'

type Props = {
  message: Message,
  onClickUpdate: () => void,
}

function SentCol({ message, onClickUpdate }: Props): React.Node {
  const messageType = message?.message_type
  const sentAt =
    message?.sent_at ||
    message?.packet_response?.created_at ||
    message?.response?.created_at ||
    message?.created_at
  const status = message.status
  const preferredDeliveryMethod = message?.preferred_delivery_method

  let sentResponseLabel = 'Pending'
  let responseType = 'pending'
  let tooltipTitle = null

  if (['failed', 'undelivered'].includes(status)) {
    sentResponseLabel = 'Failed'
    responseType = 'failed'
  } else if (messageType === 'internal') {
    sentResponseLabel = 'Internal'
    responseType = 'internal'
  } else if (messageType === 'public_response') {
    sentResponseLabel = 'Public'
    responseType = 'public'
    tooltipTitle = 'Sent'
  } else if (messageType === 'kiosk_response') {
    sentResponseLabel = 'Kiosk'
    responseType = 'kiosk'
    tooltipTitle = 'Sent'
  } else if (messageType === 'tablet_response') {
    sentResponseLabel = 'Tablet'
    responseType = 'tablet'
    tooltipTitle = 'Sent'
  } else if (message?.sent_at) {
    sentResponseLabel = momentLocal(sentAt).format('MM/DD/YYYY')
    responseType = 'sent'
    tooltipTitle = 'Sent'
  } else if (message?.scheduled_message?.scheduled_at) {
    sentResponseLabel = 'Scheduled'
    responseType = 'scheduled'
    tooltipTitle = `Scheduled for ${getFormattedDate(message.scheduled_message.scheduled_at, { format: DATE_FORMATS.FULL_DATETIME_NO_SECONDS, reverse: true })}`
  } else if (message?.response?.is_queued) {
    sentResponseLabel = 'Queued'
    responseType = 'queued'
    tooltipTitle = 'Queued'
  } else if (message?.is_waiting) {
    sentResponseLabel = 'Pre-Fill'
    responseType = 'pre-fill'
    tooltipTitle = 'Pre-Fill'
  }

  const hasFailed = ['failed', 'unkown', 'unknown', 'undelivered'].includes(
    status
  )

  const isSMS = preferredDeliveryMethod === DELIVERY_METHODS.SMS

  const failLabel = isSMS ? 'Fail to deliver SMS' : 'Fail to deliver email'

  return (
    <div className="flex items-center whitespace-nowrap">
      <Tooltip mouseEnterDelay={0.35} title={tooltipTitle}>
        <MessageStatus type={responseType}>{sentResponseLabel}</MessageStatus>
      </Tooltip>

      {hasFailed && (
        <Tooltip label={failLabel}>
          <div
            className="ml-2 flex h-5 w-5 cursor-pointer items-center justify-center rounded-full bg-red-500"
            onClick={onClickUpdate}
          >
            {isSMS ? (
              <Icons.Chat color="text-white" size={3} />
            ) : (
              <Icons.Mail color="text-white" size={3} />
            )}
          </div>
        </Tooltip>
      )}
    </div>
  )
}

export default SentCol
